import React from 'react';
import styles from './styles.module.scss';

interface ProgressSidebarProps {
  currentStep: number;
  totalSteps: number;
  title?: string;
  className?: string;
}

const ProgressSidebar: React.FC<ProgressSidebarProps> = ({
  currentStep,
  totalSteps,
  title = "Your Progress",
  className = ""
}) => {
  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <div className={`${styles.sidebar} ${className}`}>
      <div className={styles.progressText}>
        <span className={styles.currentStep}>{currentStep}</span>
        <span className={styles.separator}> of </span>
        <span className={styles.totalSteps}>{totalSteps}</span>
      </div>
      <div className={styles.container}>
        <div className={styles.progressContainer}>
          <div className={styles.progressBarContainer}>
            <div className={styles.progressBarBackground}>
              <div
                className={styles.progressBarFill}
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
          </div>
        </div>

        <div className={styles.title}>
          {title}
        </div>
      </div>

    </div>
  );
};

export { ProgressSidebar };